import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M21 9h-8a5 5 0 1 0 -5 5v7","key":"svg-0"}],["path",{"d":"M17 5l4 4l-4 4","key":"svg-1"}]]

const IconArrowRoundaboutRight = createReactComponent('outline', 'arrow-roundabout-right', 'ArrowRoundaboutRight', __iconNode);

export default IconArrowRoundaboutRight;